import React from "react";

import { SnackBarProvider } from "context/SnackBarContext";
import { Toaster } from "context/Toast/Toaster";

import AgeGate from "components/AgeGate/AgeGate";
import Footer from "components/Footer/Footer";
import { Header } from "components/Header";

import { AppSideEffects } from "./AppSideEffects";

type Props = {
  children?: React.ReactNode;
  disableFixedHeader?: boolean;
  disableHeaderCollapseOnScroll?: boolean;
  hideFooter?: boolean;
  hideHeader?: boolean;
  isAppBannerCookieDismissed?: boolean;
  showMinimalHeader?: boolean;
};

const PagesRouterLayout: React.FC<Props> = ({
  children,
  disableFixedHeader,
  disableHeaderCollapseOnScroll,
  hideFooter,
  hideHeader,
  isAppBannerCookieDismissed,
  showMinimalHeader,
}) => {
  return (
    <>
      {!hideHeader && (
        <Header
          disableFixedPosition={disableFixedHeader}
          disableScrollCollapse={disableHeaderCollapseOnScroll}
          isAppBannerCookieDismissed={isAppBannerCookieDismissed}
          minimal={showMinimalHeader}
        />
      )}
      <AgeGate />
      <AppSideEffects />

      <Toaster />
      <SnackBarProvider>
        <main>{children}</main>
        {!hideFooter && <Footer />}
      </SnackBarProvider>
    </>
  );
};

export default PagesRouterLayout;
